import { j as e } from "../../../jsx-runtime-BwWtxLpl.js";
import m from "classnames";
import f from "react";
import o from "prop-types";
import c from "../placementOptions.js";
const d = 17, u = f.forwardRef(
  ({
    placement: s = "right",
    hideArrow: l = !1,
    children: i,
    arrowProps: t = null,
    show: h = !1,
    scheduleUpdate: y = null,
    outOfBoundaries: x = null,
    ...n
  }, p) => {
    const r = m("motif-tooltip", `motif-tooltip-${s}`);
    t && t.style && t.style.top && t.style.top - d;
    const a = {
      marginTop: s === "bottom" && 0
    };
    return /* @__PURE__ */ e.jsx("div", { ref: p, className: r, "x-placement": s, ...n, "data-motif-tooltip-content": !0, children: /* @__PURE__ */ e.jsxs("div", { className: "motif-tooltip-wrapper", style: a, children: [
      !l && /* @__PURE__ */ e.jsx("div", { className: "motif-tooltip-arrow", ...t }),
      /* @__PURE__ */ e.jsx("div", { className: "motif-tooltip-inner", children: i })
    ] }) });
  }
);
u.propTypes = {
  placement: o.oneOf(c),
  arrowProps: o.shape({
    ref: o.oneOfType([o.func, o.shape({ current: o.any })]),
    style: o.object
  }),
  show: o.bool,
  children: o.node,
  scheduleUpdate: o.func,
  outOfBoundaries: o.bool,
  hideArrow: o.bool
};
export {
  u as MotifTooltipContent
};
